<router-outlet><app-loader></app-loader></router-outlet>

